import { createContext, useState } from "react";

const orderFilterContext = createContext({
    filterDate: { value: [], isActive: 0 },
    filterBread: { value: [], isActive: 0 },
    setFilterDate: () => { },
    setFilterBread: () => { },
});

export function OrderFilterProvider(props) {
    const [filterDate, setFilterDate] = useState({ value: [new Date()], isActive: 0 });
    const [filterBread, setFilterBread] = useState({
        value: [],
        isActive: 0,
    });

    const context = {
        filterDate,
        setFilterDate,
        filterBread,
        setFilterBread,
    };

    return (
        <orderFilterContext.Provider value={context}>
            {props.children}
        </orderFilterContext.Provider>
    );
}

export default orderFilterContext;
